// @flow
import { of } from 'rxjs';
import { catchError, mergeMap, map } from 'rxjs/operators';
import { putPasswordApi } from './api';
import { setNewAlert } from '../../alert/duck';
import { ofType } from 'redux-observable';

import type { Observable } from 'rxjs';
import type { HTTPError } from '../../../error';

export type PasswordAction = {
  +type: string;
  +password?: string;
  +error?: HTTPError;
};

export type PasswordState = {
  +isPuttingPassword?: boolean;
  +editSuccessful?: boolean;
  +putPasswordError?: HTTPError;
};

// Actions
const PASSWORD_PUT_PASSWORD_REQUEST = 'PASSWORD_PUT_PASSWORD_REQUEST';
const PASSWORD_PUT_PASSWORD_SUCCESS = 'PASSWORD_PUT_PASSWORD_SUCCESS';
const PASSWORD_PUT_PASSWORD_ERROR = 'PASSWORD_PUT_PASSWORD_ERROR';

// Action creators
export function editPassword(oldPassword: string, password: string): PasswordAction {
  return {
    type: PASSWORD_PUT_PASSWORD_REQUEST,
    oldPassword,
    password,
  }
}

export function editPasswordSuccess(): PasswordAction {
  return {
    type: PASSWORD_PUT_PASSWORD_SUCCESS,
  }
}

export function editPasswordError(error: HTTPError): PasswordAction {
  return {
    type: PASSWORD_PUT_PASSWORD_ERROR,
    error,
  }
}

export const actions = {
  PASSWORD_PUT_PASSWORD_REQUEST,
  PASSWORD_PUT_PASSWORD_SUCCESS,
  PASSWORD_PUT_PASSWORD_ERROR,
  editPassword,
  editPasswordSuccess,
  editPasswordError,
};

export const initialState: PasswordState = {};

// Reducer
export default function reducer(state: PasswordState = initialState,
                                action: PasswordAction): PasswordState {
  switch (action.type) {
    case PASSWORD_PUT_PASSWORD_REQUEST:
      return {
        isPuttingPassword: true,
      };
    case PASSWORD_PUT_PASSWORD_ERROR:
      return {
        putPasswordError: action.error,
      };
    case PASSWORD_PUT_PASSWORD_SUCCESS:
      return {
        editSuccessful: true,
      };
    default:
      return state;
  }
}

// Epics

export function editPasswordEpic(action$: Observable<PasswordAction>): Observable<PasswordAction> {
  return action$.pipe(
    ofType(PASSWORD_PUT_PASSWORD_REQUEST),
    mergeMap(({ password, oldPassword }) => putPasswordApi({
        currentPassword: oldPassword,
        newPassword: password,
      }).pipe(
      map(() => editPasswordSuccess()),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(editPasswordError(e),
            setNewAlert('preferences', 'error', undefined, 'httpErrors.post.500'),
          );
        }
        /* else if (e.code === 400) {
                  return Observable.of(editPasswordError(e),
                    setNewAlert('preferences', 'error', undefined, 'httpErrors.post.400'),
                  );
                }*/
        return of(editPasswordError(e));
      }))
    ));
}



// WEBPACK FOOTER //
// ./src/modules/preferences/password/duck.js